import React from 'react';

// create react context
export const rootContext = React.createContext();

// custom hook to fetch context
export const useRootStore = () => React.useContext(rootContext);
